"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FetchUrlExtension = void 0;
const core_1 = require("@remirror/core");
const Extensions_1 = require("../Extensions");
let FetchUrlExtension = class FetchUrlExtension extends core_1.PlainExtension {
    get name() {
        return 'fetchUrl';
    }
    // Implement the `onView` lifecycle method to scan for `[fetch]` and replace attributes
    onView(view) {
        const { state } = view;
        const { tr } = state;
        const promises = [];
        state.doc.descendants((node, pos) => {
            if (node.type.name === Extensions_1.NodeName.AssetImage && node.attrs.src === '') {
                promises.push(this.fetchAndReplace(node.attrs, (url) => {
                    const newNode = state.schema.nodes[Extensions_1.NodeName.AssetImage].create({ ...node.attrs, src: url });
                    tr.replaceWith(pos, pos + node.nodeSize, newNode);
                }));
            }
            if (node.type.name === Extensions_1.NodeName.DAMImage && node.attrs.src === '') {
                promises.push(this.fetchAndReplace(node.attrs, (url) => {
                    const newNode = state.schema.nodes[Extensions_1.NodeName.DAMImage].create({ ...node.attrs, src: url });
                    tr.replaceWith(pos, pos + node.nodeSize, newNode);
                }));
            }
            const assetLinkMark = this.findAssetLinkMark(node.marks);
            if (node.type.name === 'text' && assetLinkMark) {
                promises.push(this.fetchAndReplace(assetLinkMark.attrs, (url) => {
                    const updatedMark = assetLinkMark.type.create({ ...assetLinkMark.attrs, href: url });
                    tr.addMark(pos, pos + node.nodeSize, updatedMark);
                }));
            }
        });
        if (promises.length) {
            Promise.all(promises).then(() => {
                view.dispatch(tr);
            });
        }
    }
    findAssetLinkMark(marks) {
        return marks.find((mark) => mark.type.name === Extensions_1.MarkName.AssetLink && mark.attrs.href === '');
    }
    fetchAndReplace(nodeAttrs, onFetched) {
        return this.options
            .fetchUrl(nodeAttrs)
            .then((url) => {
            onFetched(url);
        })
            .catch((error) => {
            console.error('Error fetching URL:', error);
        });
    }
};
FetchUrlExtension = __decorate([
    (0, core_1.extension)({
        defaultOptions: {
            fetchUrl: () => Promise.resolve(''),
        },
    })
], FetchUrlExtension);
exports.FetchUrlExtension = FetchUrlExtension;
